import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaRocket, FaHandHoldingUsd } from "react-icons/fa";
import { FcHeadset } from "react-icons/fc";
import { verifySignup } from "../../api/api";
import { requestOtp } from "../../utils/otpUtils";
import { toast } from "react-toastify";
import AuthLayout from "../layout/AuthLayout";
import AuthBranding from "./AuthBranding";
import VerifyFormPanel from "./VerifyFormPanel";
import "../custom.css";

const verifySignupFeatures = [
  { icon: <FaRocket size={22} color="#6FE6B8" />, text: "Quick Setup" },
  { icon: <FaHandHoldingUsd size={22} color="#6FE6B8" />, text: "Low Fees" },
  { icon: <FcHeadset size={22} color="#6FE6B8" />, text: "24/7 Support" },
];

const VerifySignup = () => {
  const location = useLocation();
  const { email } = location.state || {};
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleOtpSubmit = async (otp) => {
    if (!otp || otp.length < 6) {
      toast.error("Please enter complete 6-digit OTP");
      return;
    }
    setLoading(true);
    try {
      let formData = { email, otp };
      let response = await verifySignup(formData);
      if (response.success === true) {
        toast.success(response.message || "Registration Verified!");
        navigate("/register-success");
      } else {
        toast.error(response.message || "Invalid OTP");
      }
    } catch (err) {
      toast.error(err.message || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  const contentPanel = (
    <AuthBranding
      accentText="Account"
      titleSuffix="Verification"
      subtitle="Enter the 6-digit OTP code sent to your registered email to complete your signup."
      features={verifySignupFeatures}
    />
  );

  const formPanel = (
    <VerifyFormPanel
      title="Verify Account"
      email={email}
      onSubmit={handleOtpSubmit}
      onResendOtp={() => requestOtp({ email })}
      loading={loading}
      submitText="Verify & Complete Signup"
      loadingSubmitText="Verifying..."
    />
  );

  return (
    <AuthLayout
      contentPosition="right"
      contentPanel={contentPanel}
      formPanel={formPanel}
    />
  );
};

export default VerifySignup;
